module.exports = __webpack_public_path__ + "assets/img/footer_logo_bet.880abca5.png";